import { render, staticRenderFns } from "./AdditionalServices.vue?vue&type=template&id=acb36d14&scoped=true&"
import script from "./AdditionalServices.vue?vue&type=script&lang=ts&"
export * from "./AdditionalServices.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalServices.vue?vue&type=style&index=0&id=acb36d14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb36d14",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsImageOrFallback: require('/var/www/packages/theme/components/atoms/ImageOrFallback.vue').default,IconsLeafIcon24px: require('/var/www/packages/theme/components/icons/leaf/LeafIcon24px.vue').default,IconsLeafIcon16px: require('/var/www/packages/theme/components/icons/leaf/LeafIcon16px.vue').default,IconsArrowrightArrowRight24px: require('/var/www/packages/theme/components/icons/arrowright/ArrowRight24px.vue').default,AtomsKEButton: require('/var/www/packages/theme/components/atoms/KEButton.vue').default})
